// Initial state with authChecked flag to prevent UI flash before auth resolves
const initialState = {
  data: null,
  authChecked: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "AUTH_CHECKED":
      return { ...state, authChecked: true };
    case "LOGGED_IN_USER":
      return { ...state, data: action.payload, authChecked: true };
    case "LOGOUT":
      return { ...state, data: null, authChecked: true };
    case "REFRESH_TOKEN":
      // Only update the token, keep other user data
      if (state.data && action.payload?.token) {
        return { ...state, data: { ...state.data, token: action.payload.token } };
      }
      return state;
    default:
      return state;
  }
}




export default userReducer;
